export default "__VITE_ASSET__CiP4mPnc__"